module.exports = __webpack_public_path__ + "fonts/Inter-100-vietnamese26.9df1755.woff2";